import { Z_INDEX } from '../../foundations/zIndex';
import { TableHeadVariantType } from './variants';
export const getTableHeadStyles = (FOUNDATIONS, FONT) => {
    return {
        [TableHeadVariantType.DEFAULT]: {
            container: {
                display: 'table-header-group',
                transition: 'box-shadow 200ms',
                z_index: Z_INDEX.INTERN_1,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map